import Vue from 'vue';
import Router from 'vue-router';

import Home from '@/ui/views/Home';
import TableOfContents from '@/ui/views/TableOfContents';
import Chapter from '@/ui/views/Chapter';
import Connection from '@/ui/views/Connection';
import Analytics from '@/ui/views/Analytics';
import NotFound404 from '@/ui/views/NotFound404';

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
		},
		{
            path: '/table-of-contents',
            name: 'tableOfContents',
            component: TableOfContents,
		},
		{
            path: '/chapter/:chapterId',
            name: 'chapter',
            component: Chapter
		},
		{
            path: '/connection',
            name: 'connection',
            component: Connection
		},
	{
            path: '/analytics',
            name: 'analytics',
            component: Analytics
        },
        {
            path: '*',
            name: 'notFound',
            component: NotFound404
        }
    ],
});
